// constants.js
export const CATEGORIES = [
  'New Release',
  'Keychains',
  'Memes',
  'DivineZ',
  'Throwing Dolls',
  'Women',
  'WillDress',
  'Dragon Empire',
  'Dark States',
  'Brandt Gate',
  'Keter Sanctuary',
  'Stoichea',
  'Lyrical Monasterio',
];
